import gql from 'graphql-tag';

export const logoFragment = gql`
  fragment logoFragment on Logo {
    dokkioClass
    id
    accountID
    isReusable
    name
    bytes
    width
    height
  }
`;
export default logoFragment;
